"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configDocs = void 0;
var configDocs = exports.configDocs = {
  name: 'config',
  category: 'Core',
  syntax: ['config()', 'config(options)'],
  description: 'Get configuration or change configuration.',
  examples: ['config()', '1/3 + 1/4', 'config({number: "Fraction"})', '1/3 + 1/4'],
  seealso: []
};